module.exports = __webpack_public_path__ + "img/namihira.229d0801.png";